import { useAuth } from "@/contexts/AuthContext";
import { UserCog, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
    const { user, impersonation, stopImpersonation } = useAuth();
    if (!impersonation || !user) return null;

    const handleStop = async () => {
        const r = await stopImpersonation();
        if (r.ok) {
            toast.success("Returned to your Super Admin session", {
                duration: 6000,
                id: "impersonation-stop-toast",
            });
            window.location.href = "/admin/users";
        } else {
            toast.error("Could not restore the Super Admin session", {
                duration: 5000,
                id: "impersonation-stop-toast",
            });
        }
    };

    return (
        <div
            data-testid="impersonation-banner"
            className="flex items-center justify-between gap-3 border-b border-orange-300 bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2 text-white shadow-sm"
        >
            <div className="flex items-center gap-2 text-[13px] font-medium">
                <UserCog size={16} />
                <span>
                    Acting as <span className="font-semibold">{user.name}</span>{" "}
                    <span className="font-mono text-[11px] opacity-90">({user.email})</span>
                    {" · Impersonated by "}
                    <span className="font-semibold">{impersonation.by?.email}</span>
                </span>
            </div>
            <button
                data-testid="impersonation-stop-btn"
                onClick={handleStop}
                className="inline-flex items-center gap-1.5 rounded-md bg-white/20 px-3 py-1 text-[12px] font-semibold text-white transition hover:bg-white/30"
            >
                <LogOut size={12} /> Return to Super Admin
            </button>
        </div>
    );
}
